import {combineReducers, configureStore, getDefaultMiddleware} from "@reduxjs/toolkit";
import coreSlice from "./coreSlice";
import markerSlice from "./markerSlice";
import filterSlice from "./filterSlice";
import settingsSlice from "./settingsSlice";
import mapSlice from "./mapSlice";
import defenderSlice from "./defenderSlice";
import {connectRouter} from "connected-react-router";
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router'
import {getBasePath} from "../utils";
import {filterWatcher} from "./middleware/filterWatcher";

export const history = createBrowserHistory({
	basename: getBasePath()
});

const createRootReducer = (history) => combineReducers({
	core: coreSlice,
	marker: markerSlice,
	filter: filterSlice,
	settings: settingsSlice,
	map: mapSlice,
	defenders: defenderSlice,
	router: connectRouter(history)
});

export default configureStore({
	reducer: createRootReducer(history),
	middleware: [...getDefaultMiddleware(), filterWatcher, routerMiddleware(history)]
});